import React from 'react';
import './Button.css';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  onClick, 
  type = 'button',
  className = '',
  ...props 
}) => {
  const buttonClass = `button button-${variant} button-${size} ${className}`;

  return (
    <button 
      className={buttonClass}
      onClick={onClick}
      type={type}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button; 